import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Blacklist } from 'src/model/blacklist';
import { BlacklistService } from 'src/services/blacklist.service';

@Component({
    selector: 'app-add-blacklist-customer',
    templateUrl: './add-blacklist-customer.component.html',
    styleUrls: ['./add-blacklist-customer.component.scss'],
    standalone: false
})
export class AddBlacklistCustomerComponent {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private blacklistService = inject(BlacklistService);


  name: string;
  icNumber: string;
  remark: string;
  otherId: string;
  status: string;
  disabledSubmit = false;

  reset() {
    this.activeModal.close();
  }

  checkNull() {
    return this.name == undefined || this.name == "" || this.icNumber == undefined || this.icNumber == "" || this.remark == undefined || this.remark == "" || this.status == undefined || this.status == ""
  }

  submit() {
    if (this.checkNull() == true) {
      this.sharedService.openAlert("Please fill in details correctly!", ALERT_TYPE.DANGER)
    } else {
      this.addBlacklistRecord();
    }
  }

  async addBlacklistRecord() {
    const processedICNum = this.sharedService.sanitizeICNumInput(this.icNumber);
    const b: Blacklist = {
      Name: this.name,
      ICNumber: processedICNum,
      Remark: this.remark,
      OtherID: this.otherId,
      Status: this.status
    }

    await this.blacklistService.addBlacklistCustomer(b);
    this.sharedService.openAlert("Successfully added blacklist record!", ALERT_TYPE.SUCCESS);
    this.reset();
  }
}
